// extracted by mini-css-extract-plugin
export default {"root":"Wy3FB","heading-and-subheading-block":"_1VM_8","headingAndSubheadingBlock":"_1VM_8","subheading":"_3qKmz"};